module.exports = __webpack_public_path__ + "static/media/groscopain.c3daa06d.gif";